import type { UnknownAction } from '@reduxjs/toolkit';

import { coreActions } from 'app-components/flux/core-actions';
import { hasAsyncDispatch } from 'app-components/utils/redux-store/asyncDispatchMiddleware';

import * as featureFlagsActions from './featureFlagsActions';
import * as featureFlagsTypes from './featureFlagsTypes';

let dangerouslyUseFeatureFlags: featureFlagsTypes.FeatureFlags;
export const getDangerouslyUseFeatureFlags = () => dangerouslyUseFeatureFlags;

function featureFlagsReducer(state = featureFlagsTypes.mkFeatureFlagsStore(), action: UnknownAction): typeof state {
  switch (true) {
    case coreActions.PERSIST_DATA_LOAD_COMPLETE === action.type:
      return state.merge({
        featureFlags: state.featureFlags.set('ldHasDatasetId', false), // session level flag
      });
    case featureFlagsActions.getFeatureFlags.match(action):
      return state.merge({
        isLoading: true,
        error: undefined,
      });
    case featureFlagsActions.applyFeatureFlagsChanges.match(action): {
      const featureFlags = state.featureFlags
        .withMutations((map) =>
          Object.entries(action.payload).forEach(([key, value]) =>
            map.set(key as featureFlagsTypes.FeatureFlagsKeys, value),
          ),
        )
        .sort();
      dangerouslyUseFeatureFlags = featureFlags;
      return state.merge({
        isLoading: false,
        loadPending: false,
        error: undefined,
        featureFlags,
      });
    }
    case featureFlagsActions.getFeatureFlagsSuccess.match(action): {
      if (hasAsyncDispatch(action)) {
        action.asyncDispatch(featureFlagsActions.applyFeatureFlagsChanges(action.payload, action.meta));
      }
      return state.merge({
        isLoading: false,
        loadPending: false,
        error: undefined,
      });
    }
    case featureFlagsActions.getFeatureFlagsFailure.match(action):
      return state.merge({
        error: action.payload,
        isLoading: false,
      });
    default:
      return state;
  }
}

export default featureFlagsReducer;
